import React, { useState } from 'react';
import { BiExport } from 'react-icons/bi';
import { FaSpinner } from "react-icons/fa";
import html2canvas from 'html2canvas';
import { useSelector } from 'react-redux';



const customStyles = `
  .animate-spin {
    animation: spin 1s linear infinite;
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const styleElement = document.createElement("style");
styleElement.innerHTML = customStyles;
document.head.appendChild(styleElement);

function DonwlodButton({ isLoading, children, type }) {
  const token = useSelector((state) => state?.auth?.user?.token);
  const certificate_type = useSelector((state) => state?.table?.cpdCertificateType);
  const status = useSelector((state) => state?.table?.cpdSubmissionStatus);
  const full_name = useSelector((state) => state?.table?.full_name);
  const organization = useSelector((state) => state?.table?.organization);
  const identity_number = useSelector((state) => state?.table?.identity_number);
  const typeOfCpd = useSelector((state) => state?.table?.typeOfCpd);
  const cpdSubmissionDate = useSelector((state) => state?.table?.submission_date);

const [apiLoading, setApiLoading] = useState(false);

  const handleExportClick = async () => {
    const currentPath = window.location.pathname;

    if (currentPath === '/cpd-submission') {
      try {
         setApiLoading(true);
        // Build query parameters
        const params = new URLSearchParams();
        if (certificate_type) params.append('certificate_type', certificate_type);
        if (status) params.append('status', status);
        if (full_name) params.append('full_name', full_name);
        if (organization) params.append('organization', organization);
        if (identity_number) params.append('identity_number', identity_number);
        if (typeOfCpd) params.append('type_of_cpd', typeOfCpd);
        if (cpdSubmissionDate) params.append('submission_date', cpdSubmissionDate);

        // First, get the file URL from the API
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}cpds/get-user-cpd-submission-excel?${params.toString()}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (!response.ok) {
          throw new Error('Failed to get file URL');
        }

        // Parse the JSON response to get the filePath
        const data = await response.json();
        console.log("API response:", data);
        
        if (data.status && data.filePath) {
          // Try direct download first, fallback to window.open if CORS issues
          try {
            const link = document.createElement('a');
            link.href = data.filePath;
            link.download = `cpd-submission-${new Date().toISOString().split('T')[0]}.xlsx`;
            // link.target = '_blank';
            // link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } catch (corsError) {
            console.log('Direct download failed, trying window.open:', corsError);
            // Fallback: open in new tab for user to manually download
            window.open(data.filePath, '_blank');
          }
        } else {
          throw new Error('No file path received from API');
        }
      } catch (error) {
        console.error('Error downloading file:', error);
      }
      finally {
        setApiLoading(false); // Set loading to false after API call completes
      }
    } else {
      // Screenshot functionality for other paths
      let elementClass = '.main-content';
      if (currentPath.includes('/reports')) {
        elementClass = '.pdf_chart_export';
      }
      const element = document.querySelector(elementClass);
      if (element) {
        const canvas = await html2canvas(element);
        const imgData = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        link.href = imgData;
        link.download = 'screenshot.png';
        link.click();
      } else {
        console.error(`Element with class '${elementClass}' not found.`);
      }
    }
  };

  return (
    <button
      type={type}
      className='download_btn mbot-btn-primary center-alignment'
      onClick={handleExportClick}
      disabled={isLoading}>
     {apiLoading ? (
        <FaSpinner className="animate-spin ms-2" />
      ) : (
        <BiExport
          style={{
            color: "#0F3659",
            height: "16px",
            width: "16px",
          }}
        />
      )}
      Export
      {isLoading ? <span className='loader'></span> : children}
    </button>
  );
}

export default DonwlodButton;
